import { Pagination } from '../../../../../../models/pagination-table.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { IAcceptance } from '../../../../../../models/acceptance.model';

@Component({
  selector: 'jhi-acceptances-list',
  templateUrl: './acceptances-list.component.html',
  styleUrls: ['./acceptances-list.component.scss'],
})
export class AcceptancesListComponent {
  @Input() acceptances: IAcceptance[] | undefined;
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  trackId(index: number, item: IAcceptance): number {
    return item.id!;
  }
}
